module.exports = __webpack_public_path__ + "img/富临精工.png";